var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgListCollapse = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 3.21967C5.76256 2.92678 6.23744 2.92678 6.53033 3.21967L12 8.68934L17.4697 3.21967C17.7626 2.92678 18.2374 2.92678 18.5303 3.21967C18.8232 3.51256 18.8232 3.98744 18.5303 4.28033L12.5303 10.2803C12.2374 10.5732 11.7626 10.5732 11.4697 10.2803L5.46967 4.28033C5.17678 3.98744 5.17678 3.51256 5.46967 3.21967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5303 20.7803C18.2374 21.0732 17.7626 21.0732 17.4697 20.7803L12 15.3107L6.53033 20.7803C6.23744 21.0732 5.76256 21.0732 5.46967 20.7803C5.17678 20.4874 5.17678 20.0126 5.46967 19.7197L11.4697 13.7197C11.7626 13.4268 12.2374 13.4268 12.5303 13.7197L18.5303 19.7197C18.8232 20.0126 18.8232 20.4874 18.5303 20.7803Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListCollapse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-collapse.5a5f6537b0fc8731084d67f231c63fed.svg";